import React from 'react';
import { useParams } from 'react-router-dom';

import useTitle from "../useTitle";
import loadLogo from '../../load.svg';

import './BlogPage.scss';

const BlogPage = ( props ) => {

    let { id } = useParams();

    const [ blogData, setBlogData ] = React.useState( {
        _id:'',
        excerpt: '',
        image : '',
        tags : '',
        title : ''
    } );

    var title = blogData.title ? blogData.title : id;

    useTitle( `${title} | Kalihackz` );

    React.useEffect(() => {
		fetch( `https://api.subrataghosh.repl.co/api/v1/blogs/${id}` )
        .then( function( resp ) {
            props.onLoad(50);
            return resp.json(); 
        } )
        .then( function( data ) {
            props.onLoad(100);
            return setBlogData( data.items[0] ); 
        } )
		.catch( (e) => console.log( 'Our API service is currently offline' ) );
    }, []);

    return (
        <>
        { 
            blogData.title.length === 0 ? 
            <main className="main-blog" style={{alignItems: 'center'}}>
			    <img title="Loading Blogs" src={loadLogo} alt="Loading Blogs..." style={{width:"40%"}}/>
            </main>
            : 
            <main className="blog-each">
                <img style={{width:'70%', margin:'0 auto'}} src={blogData.image} alt={blogData.title}/>
                <div className="blog-id">Blog ID : {blogData._id}</div>
                <div className="blog-tags">{blogData.tags}</div>
                <div className="blog-title">{blogData.title}</div>
                <br/>
                <div className="blog-excerpt" style={{ whiteSpace: 'break-spaces' }}>{blogData.excerpt}</div>
            </main>
        }
        </>
    );

}

export default BlogPage;